import React from 'react';
import { openAlert } from 'components/Alert/utils';

function extractBackendPayload(error) {
  const data = error && error.response && error.response.data;
  if (!data || typeof data !== 'object') {
    return { code: null, message: null };
  }

  return {
    code: data.error_code ? String(data.error_code) : null,
    message: data.message ? String(data.message) : null,
  };
}

const ALREADY_MODERATED_STATUSES = [404, 409];

export function isAlreadyModeratedError(error) {
  const response = error && error.response;

  return Boolean(
    response &&
      ALREADY_MODERATED_STATUSES.includes(response.status) &&
      response.data &&
      response.data.reason === 'already_moderated',
  );
}

function buildDescription(message, code) {
  if (message && code) {
    return React.createElement(
      React.Fragment,
      null,
      message,
      React.createElement('br'),
      React.createElement('br'),
      `Kod: ${code}`,
    );
  }

  if (message) {
    return message;
  }

  if (code) {
    return `Kod błędu: ${code}`;
  }

  return 'Nie udało się wykonać operacji. Spróbuj ponownie.';
}

/**
 * Shows a moderation action error based on what backend returned:
 * - message when present (debug envs)
 * - error_code when present (Sentry event id)
 *
 * @returns {string|null} error code from backend when available
 */
export function reportModerationActionError(error, { action, tipId }) {
  const { code, message } = extractBackendPayload(error);
  const status = error && error.response && error.response.status;
  const data = error && error.response && error.response.data;

  // eslint-disable-next-line no-console
  console.error(`[moderation ${action}] failed`, { tipId, status, code, data, error });

  if (isAlreadyModeratedError(error)) {
    openAlert(
      'error',
      'Wiadomość już rozpatrzona',
      message || 'Wiadomość została już rozpatrzona.',
    );

    return null;
  }

  openAlert('error', 'Błąd moderacji', buildDescription(message, code));

  return code;
}
